import React, { useEffect, useRef, useState } from 'react';
import { connect } from "react-redux";

import { tooltips } from "./TooltipContent"
import { closeTooltip } from "../../store/actions";
import { isMouseOverElement, isTouchScreen, setPositionToViewPort } from "../../lib/elementUtilities";

const mapDispatchToProps = dispatch => ({
  closeTooltip: () => dispatch(closeTooltip())
})

const connector = connect(null, mapDispatchToProps);

const DynamicTooltip = (props) => {
  const TooltipSpecified = tooltips[props.name];
  const divRef = useRef();

  const [style, setStyle] = useState({ display: "block", top: undefined });
  // const [overTrigger, setOverTrigger] = useState(true);
  // const [overTooltip, setOverTooltip] = useState(false);

  const handleClickOutside = (e) => {
    if (!divRef.current || divRef.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    props.closeTooltip();
  };

  const handleHoverOutTrigger = (e) => {
    if (isTouchScreen()) {
      return;
    }
    if (!divRef.current || isMouseOverElement(e.x, e.y, divRef.current)) {
      return;
    }
    props.closeTooltip();
  }

  const handleHoverOutTooltip = (e) => {
    if (isTouchScreen()) {
      return;
    }
    if (!props.elementRef.current || isMouseOverElement(e.x, e.y, props.elementRef.current)) {
      return;
    }

    props.closeTooltip();
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    if (props.elementRef.current) {
      props.elementRef.current.addEventListener("mouseleave", e => handleHoverOutTrigger(e));
      // props.elementRef.current.addEventListener("mouseover", handleHoverInTrigger);
    }
    if (divRef.current) {
      divRef.current.addEventListener("mouseleave", e => handleHoverOutTooltip(e));
      // divRef.current.addEventListener("mouseover", handleHoverInTooltip);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
      if (props.elementRef.current) {
        props.elementRef.current.removeEventListener("mouseleave", handleHoverOutTrigger);
        // props.elementRef.current.removeEventListener("mouseover", handleHoverInTrigger);
      }
      if (divRef.current) {
        divRef.current.removeEventListener("mouseleave", handleHoverOutTooltip);
        // divRef.current.removeEventListener("mouseover", handleHoverInTooltip);
      }
    };
  }, []);

  useEffect(() => {
    // const body = document.querySelector("body");
    let position = {};

    if (props.triggerDimension) {
      position.left = props.triggerDimension.left
        - (divRef.current.getBoundingClientRect().width
          - props.triggerDimension.width) / 2;
      position.top = props.triggerDimension.bottom;
    } else if (props.elementRef) {
      position.left = props.elementRef.current.getBoundingClientRect().left
        - (divRef.current.getBoundingClientRect().width
          - props.elementRef.current.getBoundingClientRect().width) / 2 + window.scrollX;
      position.top = props.elementRef.current.getBoundingClientRect().bottom + window.scrollY;
    }

    if (divRef.current) {
      position = setPositionToViewPort(divRef.current, position);
    }

    setStyle({
      ...style,
      ...position
    })
  }, [props.elementRef]);

  return (
    <div className={`tooltip ${props.classes?.join(" ")}`}
         ref={divRef}
         style={style}
         onMouseLeave={!isTouchScreen() && props.closeControl && props.closeTooltip}
    >
      {props.title && <h3 className="title">{props.title}</h3>}
      {<TooltipSpecified {...props}/>}
    </div>
  )
}

export default connector(DynamicTooltip);
